import { DiveBreakpoint } from '@dce-front/dive';
import { useWindowSize } from 'usehooks-ts';

const IS_SERVER = typeof window === 'undefined';
const DEBOUNCE_DELAY = 250;

/**
 * This hook helps Dive's nav (Header, Tabs) consumers adapt their UI based on common business requirements
 * without having to manually check these conditions each time:
 * - `canHaveDropdown`: should have overflow dropdown only on desktop screen.
 * - `canCenterActiveItem`: should auto center active item only on mobile
 */
export function useDiveNavConfig() {
  const { width: windowWidth } = useWindowSize({
    debounceDelay: DEBOUNCE_DELAY,
  });

  const isMobileWidth = windowWidth < DiveBreakpoint.Sm;

  const canCenterActiveItem =
    !IS_SERVER && !$_BUILD_RENDERMODE_CSR && isMobileWidth;

  const canHaveDropdown =
    !IS_SERVER && !$_BUILD_RENDERMODE_CSR && !isMobileWidth;

  return {
    canHaveDropdown,
    canCenterActiveItem,
  };
}
